import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OuiButton } from 'omnium-ui/button';
import { OuiErrorPageComponent } from 'omnium-ui/error-page';

@Component({
  selector: 'lib-request-error-page',
  imports: [OuiErrorPageComponent, OuiButton],
  templateUrl: './request-error-page.component.html',
  styleUrl: './request-error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestErrorPageComponent {
  reloadPage() {
    window.location.reload();
  }
}
